import * as React from "react";
import { KModal } from "../../../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../../../ui-kit/k-modal/k-modal-footer";
import KuikaModalIconWrapper from "../../../../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaH5 from "../../../../ui-kit/typography/H5/H5";
import KuikaText from "../../../../ui-kit/typography/Text/Text";

interface Props {
  onOk: () => void;
  onCancel: () => void;
}

export const ConvertToSqlConfirmationModal: React.FunctionComponent<Props> = (props) => {
  const footer = (
    <KModalFooter
      onCancel={props.onCancel}
      cancelTestId="convertSqlModalCancelButton"
      submitLabel="Convert"
      submitTestId="convertSqlModalConvertButton"
      onSubmit={props.onOk}
    />
  );

  return (
    <KModal
      showModal={true}
      closeModal={props.onCancel}
      header="Convert to SQL Action"
      footer={footer}
      width={400}
      centered
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          padding: "24px 0"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px"
          }}
        >
          <KuikaModalIconWrapper iconName="arrow-back-up-x" intent="warning" />
          <KuikaH5>Convert to SQL Action</KuikaH5>
        </div>
        <div style={{ textAlign: "center" }}>
          <KuikaText>
            Are you sure you want to convert the query to an SQL action? This process cannot be undone.
          </KuikaText>
        </div>
      </div>
    </KModal>
  );
};
